import React from "react";
import {Modal, useObject,} from "@vokymlak/kabinet-ui";
import {ROOT_URL} from "../../config/url";

function ModalProfileTelegramAdd(props) {
  const {
    object: [object],
  } = useObject({
    apiUrl: "/api/profile/telegram-link",
    rootUrl: ROOT_URL,
    callbackError: () => {
      props.handleClose();
    },
  });

  return (
    !!object &&
    <Modal handleClose={() => props.handleClose()}>
      <form className="Form">
        <div className="Form__title">
          Привязать телеграм аккаунт
        </div>

        <div className="Form__field">
          <a style={{
            display: "inline-block"
          }}
             href={object.telegram_link}
             className="Action__link Action__link_blue"
             target={"_blank"}
             onClick={() => props.handleClose()}
          >
            Перейти в телеграм бот
          </a>
        </div>

        <div className="Form__actions Form__actions_center">
          <div className="Action__link" onClick={() => props.handleClose()}>
            Отмена
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default ModalProfileTelegramAdd;
